<template>
  <b-row>
    <b-col cols="10 mb-2">
      <multiselect
        v-model="fieldsSelected"
        :options="fields"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        placeholder="Selecione Columna..."
        label="name"
        track-by="name"
        :preselect-first="true"
      >
        <template slot="selection" slot-scope="{ values, search, isOpen }">
          <span
            class="multiselect__single"
            v-if="values.length &amp;&amp; !isOpen"
            >{{ values.length }} opciones selecionadas</span
          >
        </template>
      </multiselect>
    </b-col>

    <b-col>
      <b-dropdown
        text="Opciones"
        class="btn b-dropdown text-right col-sm-12"
        variant="success"
      >
        <b-dropdown-item @click="addCustomer()" :disabled="!CREATE"
          >Crear</b-dropdown-item
        >
        <b-dropdown-item @click="openModal('dlgImportarCuentas')"
          >Importar cuentas</b-dropdown-item
        >
        <b-dropdown-item @click="openModal('dlgImportarGestiones')"
          >Importar gestiones</b-dropdown-item
        >
        <b-dropdown-item @click="openModal('dlgImportarContactos')"
          >Importar contactos</b-dropdown-item
        >
        <b-dropdown-item @click="openModal('dlgImportarContratos')"
          >Importar contratos/ordenes de servicio</b-dropdown-item
        >
        <b-dropdown-item v-if="isAdmin">
          <downloadExcel
            :data="filteredItems()"
            worksheet="Cuentas"
            name="cuentas.xls"
            :fields="json_fields"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            >Exportar</downloadExcel
          >
        </b-dropdown-item>
      </b-dropdown>
    </b-col>

    <h5 class="col-sm-12 mt-2">Filtrar por</h5>

    <b-col sm="2">
      <b-form-group>
        <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
        <b-form-input
          type="date"
          id="txtFechaDesde"
          v-model="range.startDate"
          :max="range.endDate == '' ? maxDate : range.endDate"
          @blur="changeDate()"
        ></b-form-input>
      </b-form-group>
    </b-col>
    <b-col sm="2">
      <b-form-group>
        <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
        <b-form-input
          type="date"
          id="txtFechaHasta"
          v-model="range.endDate"
          :min="range.startDate"
          :max="maxDate"
          @blur="changeDate()"
        ></b-form-input>
      </b-form-group>
    </b-col>

    <b-col sm="3">
      <b-form-group>
        <label class="mb-0">NIT / CC</label>
        <b-form-input
          type="text"
          v-model="identification"
          placeholder="NIT / CC"
          @blur="getCustomers()"
        ></b-form-input>
      </b-form-group>
    </b-col>

    <b-col sm="3">
      <b-form-group>
        <label class="mb-0">Empresa</label>
        <b-form-input
          type="text"
          v-model="business_name"
          placeholder="Empresa"
          @blur="getCustomers()"
        ></b-form-input>
      </b-form-group>
    </b-col>

    <b-col>
      <b-form-group>
        <label class="mb-0">Estado</label>
        <b-form-select v-model="statusFilter" @change="getCustomers()">
          <template slot="first">
            <option :value="null">-- Estado--</option>
          </template>
          <option value="P">Por activar</option>
          <option value="A">Activo</option>
          <option value="I">Inactivo</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col sm="2">
      <b-form-group>
        <label class="mb-0">Avance</label>
        <b-form-select v-model="advance" @change="getAdvanceLevel()">
          <template slot="first">
            <option :value="null">-- Avance --</option>
          </template>
          <option v-for="item in lstAdvance" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col sm="2">
      <b-form-group>
        <label class="mb-0">Grado avance</label>
        <b-form-select
          v-model="advance_level"
          @change="getCustomers()"
          :disabled="advance == null"
        >
          <template slot="first">
            <option :value="null">-- Grado avance --</option>
          </template>
          <option
            v-for="item in lstAdvanceLevel"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-if="role_id == 1 || role_id == 7">
      <b-form-group>
        <label class="mb-0">Comercial</label>
        <b-form-select v-model="staff_idFilter" @change="getCustomers()">
          <template slot="first">
            <option :value="null">-- Comercial--</option>
          </template>
          <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
            {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col sm="2">
      <b-form-group>
        <label class="mb-0">Industria</label>
        <b-form-select v-model="industries_id" @change="getSubIndustries()">
          <template slot="first">
            <option :value="null">-- Industria --</option>
          </template>
          <option v-for="item in lstIndustries" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col sm="3">
      <b-form-group>
        <label class="mb-0">Sub industria</label>
        <b-form-select
          v-model="sub_industries_id"
          @change="getCustomers()"
          :disabled="industries_id == null"
        >
          <template slot="first">
            <option :value="null">-- Sub industria --</option>
          </template>
          <option
            v-for="item in lstSubIndustries"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col sm="4">
      <b-form-group>
        <label for="cmbDepartamentoFiltro">Departamento</label>
        <b-form-select
          v-model="zone_id"
          id="cmbDepartamentoFiltro"
          @change="getCitiesByZone(zone_id)"
        >
          <template slot="first">
            <option :value="null">-- Por favor seleccione una opción --</option>
          </template>

          <option
            v-for="item in lstDepartamento"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col sm="4">
      <b-form-group>
        <label for="cmbCiudadFiltro">Ciudad</label>
        <b-form-select
          v-model="city_id"
          id="cmbCiudadFiltro"
          :disabled="zone_id == null"
          @change="getCustomers()"
        >
          <template slot="first">
            <option :value="null">-- Por favor seleccione una opción --</option>
          </template>

          <option v-for="item in lstCiudad" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <br />
    <br />

    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card :header="caption">
          <!-- <div slot="header">
            <b-form-group label-cols-sm="1" :label="caption">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" v-model="filter" placeholder="Buscar cuenta"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''" variant="warning">Limpiar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>-->

          <div v-if="isAdmin">
            <!-- <div class="row" v-if="itemsChecked"> -->
            <div class="row" v-if="selectItems.length > 0">
              <div class="col-sm-4">
                <b-form-group>
                  <b-form-select
                    id="cmbEstado"
                    v-model="status"
                    @change="actualizarEstado()"
                  >
                    <template slot="first">
                      <option :value="null" disabled>
                        -- Actualizar Estado--
                      </option>
                    </template>
                    <option value="P">Por activar</option>
                    <option value="A">Activo</option>
                    <option value="I">Inactivo</option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="col-sm-4">
                <b-form-group>
                  <b-form-select
                    id="cmbComercial"
                    v-model="staff_id"
                    @change="actualizarComercial()"
                  >
                    <template slot="first">
                      <option :value="null" disabled>
                        -- Asignar Comercial--
                      </option>
                    </template>
                    <option
                      v-for="item in lstStaffs"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }} {{ item.last_name }} ({{
                        item.type_name
                      }})
                    </option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="col-sm-2">
                <downloadExcel
                  class="btn btn-warning col-sm-12"
                  :data="itemChecked"
                  :fields="json_fields"
                  worksheet="Cuentas"
                  name="cuentas.xls"
                  :before-generate="startDownload"
                  :before-finish="finishDownload"
                  >Exportar</downloadExcel
                >
              </div>

              <div class="col-sm-2">
                <b-button
                  variant="danger"
                  class="float-right col-sm-12"
                  @click="eliminarSeleccionados"
                  >Eliminar</b-button
                >
              </div>
            </div>
          </div>

          <b-table
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="filteredItems()"
            :fields="fieldsSelected"
            :filter="filter"
          >
            <!-- <template :slot="`HEAD_${ key }`" v-for="key in fieldKeys()" slot-scope="data">
              <b :key="key">{{ data.label }}</b>
              <select :key="key"  class="form-control form-control-sm" @click.stop.prevent v-model="selectVal[key]">
                <option :value="undefined">Seleccionar...</option>
                <option :value="option" v-for="option in options()[key]" :key="option">{{ option }}</option>
              </select>
            </template> -->

            <template slot="HEAD_selected" v-if="isAdmin">
              <input type="checkbox" @click.stop v-model="selectAll" @change="toggleSelectAll" />
            </template>

            <template slot="selected" slot-scope="data" v-if="isAdmin">
              <input
                type="checkbox"
                v-model="data.item.selected"
                @change="selectRow(data.item)"
              />
            </template>

            <template slot="status" slot-scope="data">
              <b-badge :variant="getBadge(data.item.status)">{{
                getTextStatus(data.item.status)
              }}</b-badge>
            </template>

            <!-- <template v-slot:cell(actions)="data"> -->
            <template slot="actions" slot-scope="data">
              <b-button
                v-if="data.item.status === 'A' || isAdmin"
                size="sm"
                variant="primary"
                class="mr-1 btn-custom-size"
                @click="viewCustomer(data.item.id)"
                title="Gestionar"
                :disabled="!READ"
              >
                <i class="fa fa-eye"></i>
              </b-button>

              <b-button
                v-else
                size="sm"
                variant="primary"
                class="mr-1 btn-custom-size"
                :disabled="true"
                title="Gestionar"
              >
                <i class="fa fa-eye"></i>
              </b-button>

              <b-button
                size="sm"
                variant="success"
                class="mr-1 btn-custom-size"
                @click="editCustomer(data.item.id)"
                title="Editar"
                :disabled="!UPDATE"
              >
                <i class="fa fa-edit"></i>
              </b-button>

              <b-button
                size="sm"
                variant="warning"
                class="mr-1 btn-custom-size"
                title="Crear actividad"
                @click="addtask(data.item)"
                :disabled="!CREATE"
              >
                <i class="fa fa-calendar"></i>
              </b-button>

              <b-button
                size="sm"
                v-if="role_id == 1 || role_id == 7"
                variant="danger"
                class="btn-custom-size"
                @click="deleteCustomer(data.item.id)"
                title="Eliminar"
                :disabled="!DELETE"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>

          <hr />
          <div class="row">
            <div class="col-sm-4">
              Mostrando {{ laravelData.to }} de
              {{ laravelData.total }} registros
            </div>
            <div class="col-sm-8">
              <nav>
                <b-pagination
                  size="sm"
                  align="right"
                  :limit="10"
                  :total-rows="laravelData.total"
                  :per-page="laravelData.per_page"
                  v-model="laravelData.current_page"
                  @change="getCustomers"
                  prev-text="Anterior"
                  next-text="Siguiente"
                />
              </nav>
            </div>
          </div>
        </b-card>
      </transition>
    </b-col>

    <!-- MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
    <div class="modal fade" id="dlgCrearActividad">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">ACTIVIDAD</h4>
            <button type="button" class="close" @click="closetask()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <activity-component
              :customer_id="this.customer_id"
              :private="'S'"
              :_task="null"
              :_disabled="false"
              v-if="this.customer_id"
              :title="null"
              :dlg="'dlgCrearActividad'"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->

    <upload-data-component v-if="opt.show" :options="opt" />
  </b-row>
</template>

<script>
import UploadDataComponent from "@/components/UploadData.vue";
import UploadExcelComponent from "@/components/ImporterExcel.vue";
import ActivityComponent from "@/components/Activity.vue";
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";

export default {
  name: "customers",
  components: {
    UploadExcelComponent,
    ActivityComponent,
    DateRangePicker,
    UploadDataComponent,
  },
  props: {
    caption: {
      type: String,
      default: "CUENTAS",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range: {
        // startDate: new Date("2015", "01", "01"),
        // endDate: new Date()
        startDate: moment(String(new Date("2014", "12", "31"))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      tableData: [],
      tableHeader: [],
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      isCustomer: false,
      selectAll: false,
      status: null,
      staff_id: null,
      customer_id: null,
      customer_name: null,
      json_fields: {
        Empresa: "business_name",
        // Tipo: "type",
        "NIT / CC": "identification",
        DV: "check_digit",
        Avance: "advance_name",
        Nivel: "advance_level_name",
        "Correo de facturación": "billing_mail",
        "Télefono de facturación": "billing_phone",
        "Celular de facturación": "billing_mobile",
        "Dirección de facturación": "billing_address",
        "Barrio de facturación": "billing_neighborhood",
        // "Cobra honorarios": "fee",
        "Cartera prescrita": "pre_written",
        "Montos minimos": "smaller_amount",
        Comentarios: "observation",
        Estado: "status",
        "Campos personalizados": "check_field",
        "Fecha creación": "created_at",
        "Fecha última actualización": "updated_at",
        Encargado: "staff_name",
      },

      fields: [
        {
          key: "selected",
          field: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },
        {
          key: "advance_name",
          field: "advance_name",
          name: "Avance",
          label: "Avance",
        },
        {
          key: "advance_level_name",
          field: "advance_level_name",
          name: "Nivel",
          label: "Nivel",
        },
        { key: "status", field: "status", name: "Estado", label: "Estado" },
        {
          key: "business_name",
          field: "business_name",
          name: "Empresa",
          label: "Empresa",
        },
        // { key: "contact_name", name: "Contacto", label: "Contacto" },
        { key: "phone", field: "phone", name: "Teléfono", label: "Teléfono" },
        { key: "to_do", field: "to_do", name: "To Do", label: "To Do" },
        {
          key: "staff_name",
          field: "staff_name",
          name: "Responsable",
          label: "Responsable",
        },

        {
          key: "actions",
          field: "actions",
          name: "Opciones",
          label: "Opciones",
          $isDisabled: true,
        },
      ],

      items: [],
      selectItems: [],
      itemChecked: [],
      itemsChecked: false,
      lstStaffs: [],
      pagination: {},
      rowCount: -1,
      mostrarResumen: false,
      fieldsSelected: [],
      selectVal: {},
      filter: null,
      lstAdvance: [],
      lstAdvanceLevel: [],
      statusFilter: null,
      staff_idFilter: null,
      advance: null,
      advance_level: null,
      business_name: null,
      identification: null,
      errores: [],

      lstDepartamento: [],
      lstCiudad: [],

      // PARA LA PAGINACIÓN
      laravelData: {},
      limit: 5,
      showDisabled: true,
      size: "small",
      align: "right",
      lstIndustries: [],
      lstSubIndustries: [],
      industries_id: null,
      sub_industries_id: null,
      zone_id: null,
      city_id: null,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA IMPORTACIÓN DE DATOS
      // ------------------------------------------------------------------------
      opt: { show: false },

      dataImportCuentas: {
        show: true,
        id: "dlgImportarCuentas",
        title: "IMPORTAR CUENTAS",
        url: `customers/storeexcel`,
      },
      dataImportarGestiones: {
        show: true,
        id: "dlgImportarGestiones",
        title: "IMPORTAR GESTIONES",
        type_store: "customer",
        url: `taskmanagements/storeexcel`,
      },
      dataImportarContactos: {
        show: true,
        id: "dlgImportarContactos",
        title: "IMPORTAR CONTACTOS",
        type_store: "customer",
        url: `contacts/storeexcel`,
      },
      dataImportarContratos: {
        show: true,
        id: "dlgImportarContratos",
        title: "IMPORTAR CONTRATOS/ORDENES DE SERVICIO",
        url: `agreements/storeexcel`,
      },
      // ------------------------------------------------------------------------
      // FIN VARIABLES PARA LA IMPORTACIÓN DE DATOS
      // ------------------------------------------------------------------------
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  mounted() {
    this.enabledActions();
    var auth = localStorage.getItem("auth");
    auth = JSON.parse(auth);
    this.staff_idFilter =
      this.role_id == 1 || this.role_id == 7 ? null : auth[0].staff_id;

    this.isCustomer = auth[0].customer_id != null ? true : false;
    this.fieldsSelected = this.fields;
    this.getCustomers();

    //LISTADO DE STAFF'S: 42: COMERCIAL
    this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
      (response) => {
        this.lstStaffs = response.data.data;
        // console.log(response.data.data);
      },
      (error) => {
        console.log(error);
      }
    );

    // 4: AVANCE CLIENTE
    this.$http.get(`${this.$urlApi}parameters/4?token=${this.token}`).then(
      (response) => {
        this.lstAdvance = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );

    // INSDUSTRIAS
    this.$http.get(`${this.$urlApi}industries?token=${this.token}`).then(
      (response) => {
        this.lstIndustries = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );

    //DEPARTAMENTOS DE COLOMBIA
    this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
      (response) => {
        this.lstDepartamento = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );
  },
  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },

    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys().forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      let keys = ["status", "advance_name", "advance_level_name"];
      return keys;

      if (this.items[0] === undefined) return null;
      else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys())
      this.fieldKeys().forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },
    getCustomers_: function (urlPage) {
      showLoader();

      let authAux = JSON.parse(this.auth);

      authAux[0].status = this.statusFilter;
      authAux[0].filter_staff_id = this.staff_idFilter;
      authAux[0].advance = this.advance;
      authAux[0].advance_level = this.advance_level;
      authAux[0].business_name = this.business_name;
      authAux[0].start_date = moment(this.range.startDate).format("YYYY-MM-DD");
      authAux[0].end_date = moment(this.range.endDate).format("YYYY-MM-DD");

      //console.log(authAux)
      //return false

      // DETERMINAR EL NUMERO DE LA PAGINA
      let page = darNumeroPaginaPaginacion(urlPage);

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = "";
      // VALIDAR QUE URL VA A TRABAJAR
      // if(authAux[0].is_admin === 'S') url = `${this.$urlApi}customers/filter?token=${this.token}&page=${page}`
      // else url = `${this.$urlApi}customers?token=${this.token}&page=${page}`

      url = `${this.$urlApi}customers/filter?token=${this.token}&page=${page}`;

      // if (authAux[0].is_admin === "N") {
      //   authAux[0].filter_staff_id = authAux[0].staff_id;
      // }

      //console.log(url)
      //showLoader()
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            this.items = response.data.data.data;
            //console.log(response)
            this.pagination = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    changeDate() {
      if (this.range.startDate != "" && this.range.endDate != "") {
        this.getCustomers();
      } else return;
    },
    getCustomers: function (page = 1) {
      showLoader();

      let authAux = JSON.parse(this.auth);

      authAux[0].status = this.statusFilter;
      authAux[0].filter_staff_id = this.staff_idFilter;
      authAux[0].advance = this.advance;
      authAux[0].advance_level = this.advance_level;
      authAux[0].business_name = this.business_name;
      authAux[0].identification = this.identification;
      authAux[0].start_date = moment(this.range.startDate).format("YYYY-MM-DD");
      authAux[0].end_date = moment(this.range.endDate).format("YYYY-MM-DD");
      authAux[0].sub_industries_id = this.sub_industries_id;


      authAux[0].zone_id = this.zone_id;
      authAux[0].city_id = this.city_id;
      // console.log(authAux[0]);

      let url = `${this.$urlApi}customers/filter?token=${this.token}&page=${page}`;

      // if (authAux[0].is_admin === "N") {
      //   authAux[0].filter_staff_id = authAux[0].staff_id;
      // }

      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);
            this.items = response.data.data.data;
            this.laravelData = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return getTextStatus(status);
    },
    _selectRow(item) {
      var length = item.selectedRows.length;
      this.itemChecked = [];
      if (length > 0) {
        this.itemChecked = item.selectedRows;
        this.itemsChecked = true;
      } else {
        this.itemsChecked = false;
      }
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
      //console.log(this.selectItems)
    },
    addCustomer() {
      this.$router.push({ path: `customers/add` });
    },
    deleteCustomer(id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la cuenta!",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}customers/${id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Cuenta eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getCustomers();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              //alert(error.body.error)
              hideLoader();
            });
        }
      });
    },
    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },
    editCustomer(id) {
      this.$router.push({ path: `customers/edit/${id.toString()}` });
    },
    viewCustomer(id) {
      let url = `${location.origin}/#/customers/view/${id.toString()}`;
      window.open(url, "_blank");
    },
    actualizarEstado() {
      this.$swal({
        title: "Actualizar",
        text: "Se actualizará el estado de las cuentas seleccionados ¿Desea continuar?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();

          let registrosActualizados = 0;

          for (var i = 0; i < this.items.length; i++) {
            var updatingItem = this.items[i];
            if (updatingItem.selected) {
              updatingItem.status = this.status;
              updatingItem.url = `${location.origin}/#/customers/view/${updatingItem.id}`;
              let id = updatingItem.id;
              console.log(updatingItem);
              let datos = JSON.stringify(updatingItem);
              //console.log(datos)
              //return false
              this.$http
                .put(
                  `${this.$urlApi}customers/changestatus/${id}?token=${this.token}`,
                  datos,
                  { headers: { "Content-Type": "application/json" } }
                )
                .then(function (response) {
                  console.log(response);
                })
                .catch((error) => {
                  console.log(error.body.message);
                });
              registrosActualizados = registrosActualizados + 1;
            }
          }

          if (registrosActualizados > 0) {
            hideLoader();
            this.$swal({
              title: "Buen trabajo",
              text: "Estados actualizados correctamente!",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            }).then((result) => {
              if (result.value) {
                this.getCustomers();
              }
            });
          }

          this.status = null;
          console.log(
            "----------------------Actualizados-----------------------------"
          );
        }
      });
    },
    actualizarComercial() {
      this.$swal({
        title: "Actualizar",
        text: "Se asignaran a un ejecutivo comercial a las cuentas seleccionadas ¿Desea continuar?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          let registrosActualizados = 0;

          for (var i = 0; i < this.items.length; i++) {
            var updatingItem = this.items[i];
            if (updatingItem.selected) {
              let id = updatingItem.id;
              updatingItem.staff_id = this.staff_id;
              updatingItem.url = `${
                location.origin
              }/#/customers/view/${id.toString()}`;
              let datos = JSON.stringify(updatingItem);
              //console.log(datos)
              this.$http
                .put(
                  `${this.$urlApi}customers/changestaff/${id}?token=${this.token}`,
                  datos,
                  { headers: { "Content-Type": "application/json" } }
                )
                .then(function (response) {
                  //console.log(response)
                })
                .catch((error) => {
                  console.log(error);
                });
              registrosActualizados = registrosActualizados + 1;
            }
          }

          if (registrosActualizados > 0) {
            this.$swal({
              title: "Buen trabajo",
              text: "Comerciales actualizados correctamente!",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            }).then((result) => {
              if (result.value) {
                this.getCustomers();
              }
            });
          }

          this.staff_id = null;
          console.log(
            "----------------------Actualizados-----------------------------"
          );
        }
      });
    },
    eliminarSeleccionados() {
      this.$swal({
        title: "Eliminar",
        text: "Se eliminaran todas las cuentas seleccionadas, esta opción es irreversible ¿Desea continuar?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          this.rowCount = 0;
          for (var i = 0; i < this.items.length; i++) {
            var updatingItem = this.items[i];
            if (updatingItem.selected) {
              let id = updatingItem.id;
              //console.log(id)
              this.$http
                .delete(`${this.$urlApi}customers/${id}?token=${this.token}`, {
                  headers: { "Content-Type": "application/json" },
                })
                .then(function (response) {
                  //console.log(response)
                })
                .catch((error) => {
                  console.log(error.body.message);
                });

              this.rowCount++;
            }
          }

          if (this.rowCount > 0) {
            this.$swal({
              title: "Buen trabajo",
              text: "Registros eliminados correctamente!",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            }).then((result) => {
              if (result.value) {
                this.getCustomers();
                this.rowCount = 0;
              }
            });
          }
          console.log(
            "----------------------Eliminados-----------------------------"
          );
        }
      });
    },
    beforeUpload(file) {
      this.tableData = [];
      this.tableHeader = [];
      this.mostrarResumen = false;

      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      } else {
        this.$swal({
          title: "Advertencia",
          text: "Por favor, no cargue archivos de más de 1M de tamaño.",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        }).then((result) => {
          return false;
        });

        return false;
      }
    },
    handleSuccess({ results, header }) {
      this.tableData = results;
      this.tableHeader = header;
      this.tableData.splice(0, 2); // SE QUITA LAS DOS FILAS QUE NO TIENEN DATOS, SOLO SON ENCABEZADOS
      //console.log(this.tableData)
      this.mostrarResumen = true;
      this.$swal({
        title: "Buen trabajo",
        text: "Items leidos correctamente!",
        type: "success",
        showCancelButton: false,
        confirmButtonText: "Aceptar",
      }).then((result) => {});
    },
    storeExcel() {
      showLoader();

      this.rowCount = 0;
      this.errores = [];

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];
        //console.log(item)
        let datos = JSON.stringify(item);
        //console.log(datos)
        //return false
        this.$http
          .post(
            `${this.$urlApi}customers/storeexcel?token=${this.token}`,
            datos,
            { headers: { "Content-Type": "application/json" } }
          )
          .then(function (response) {
            //showLoader()
            console.log(response.data.message);
            console.log(response.data);
            if (response.data.success == false) {
              this.errores.push(response.data.message);
              this.rowCount--;
            }
            //this.rowCount ++
          })
          .catch((error) => {
            this.rowCount--;
            this.errores.push(error.body.message);
            console.log(error);
          });

        this.rowCount++;
      }

      if (this.rowCount > 0) {
        hideLoader();
        this.$swal({
          title: "Buen trabajo",
          text: "Cuentas importadas",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        }).then((result) => {
          //$('#dlgImportarCuentas').modal('hide')
          this.getCustomers();
        });
      }
    },
    addtask(item) {
      $("#dlgCrearActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.customer_id = item.id;
      this.customer_name = item.business_name;
      $("#dlgCrearActividad").modal("show");
    },
    closetask() {
      this.customer_id = null;
      $("#dlgCrearActividad").modal("hide");
    },
    getAdvanceLevel() {
      this.advance_level = null;
      this.getCustomers();

      this.$http
        .get(
          `${this.$urlApi}parameters/advance/${this.advance}?token=${this.token}`
        )
        .then(
          (response) => {
            this.lstAdvanceLevel = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    storeExcelGestion() {
      showLoader();
      this.rowCount = 0;
      this.errores = [];

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];
        item.user_id = auth[0].id;
        item.type_store = "customer";
        let datos = JSON.stringify(item);
        // console.log(datos)
        // return false
        this.$http
          .post(
            `${this.$urlApi}taskmanagements/storeexcel?token=${this.token}`,
            datos,
            { headers: { "Content-Type": "application/json" } }
          )
          .then(function (response) {
            //showLoader()
            console.log(response.data);
            if (response.data.success == false) {
              this.errores.push(response.data.message);
              this.rowCount--;
            }
          })
          .catch((error) => {
            this.rowCount--;
            this.errores.push(error.body.message);
            console.log(error);
          });

        this.rowCount++;
      }

      if (this.rowCount > 0) {
        hideLoader();
        this.$swal({
          title: "Buen trabajo",
          text: "Gestiones importadas",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        // .then((result) => {
        //   //$('#dlgImportarCuentas').modal('hide')
        //   this.getTaskManagement()
        // })
      }
    },

    storeExcelContacts() {
      this.rowCount = 0;
      this.errores = [];

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];
        item.user_id = auth[0].id;
        item.type = "customer";
        let datos = JSON.stringify(item);
        showLoader();
        // console.log(datos)
        // return false
        this.$http
          .post(
            `${this.$urlApi}contacts/storeexcel?token=${this.token}`,
            datos,
            { headers: { "Content-Type": "application/json" } }
          )
          .then(function (response) {
            //showLoader()
            console.log(response.data);
            if (response.data.success == false) {
              this.errores.push(response.data.message);
              this.rowCount--;
            } else {
              this.rowCount++;
            }
            hideLoader();
          })
          .catch((error) => {
            this.rowCount--;
            this.errores.push(error.body.message);
            console.log(error);
            hideLoader();
          });
      }

      if (this.rowCount > 0) {
        hideLoader();
        // alert(this.rowCount);

        this.$swal({
          title: "Buen trabajo",
          text: "Contactos importados",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
      }
      // hideLoader();
    },

    storeExcelAgreementsAndServiceOrders() {
      this.rowCount = 0;
      this.errores = [];

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];
        item.user_id = auth[0].id;
        let datos = JSON.stringify(item);
        showLoader();
        // console.log(datos)
        // return false
        this.$http
          .post(
            `${this.$urlApi}agreements/storeexcel?token=${this.token}`,
            datos,
            { headers: { "Content-Type": "application/json" } }
          )
          .then(function (response) {
            //showLoader()
            console.log(response.data);
            if (response.data.success == false) {
              this.errores.push(response.data.message);
              this.rowCount--;
            } else {
              this.rowCount++;
            }
            hideLoader();
          })
          .catch((error) => {
            this.rowCount--;
            this.errores.push(error.body.message);
            console.log(error);
            hideLoader();
          });
      }

      if (this.rowCount > 0) {
        hideLoader();
        // alert(this.rowCount);

        this.$swal({
          title: "Buen trabajo",
          text: "Contratos y ordenes de servicio importadas",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
      }
      // hideLoader();
    },
    openModal(option) {
      showLoader();

      this.opt = { show: false };

      setTimeout(() => {
        switch (option) {
          case "dlgImportarCuentas":
            // this.dataImportCuentas.show = true;
            this.opt = this.dataImportCuentas;
            break;
          case "dlgImportarGestiones":
            // this.dataImportarGestiones.show = true;
            this.opt = this.dataImportarGestiones;
            break;
          case "dlgImportarContactos":
            this.opt = this.dataImportarContactos;
            break;
          case "dlgImportarContratos":
            this.opt = this.dataImportarContratos;
            break;
        }
      }, 200);

      return;

      // $("#" + id).modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      // $("#" + id).modal("show");
    },
    finalizarImport(id) {
      // alert(id);
      this.tableData = [];
      this.tableHeader = [];
      this.errores = [];
      this.rowCount = -1;
      $("#" + id).modal("hide");
    },
    getSubIndustries() {
      if (this.industries_id != null) {
        showLoader();
        this.$http
          .get(
            `${this.$urlApi}subindustries/${this.industries_id}?token=${this.token}`
          )
          .then(
            (response) => {
              this.lstSubIndustries = response.data.data;
              hideLoader();
            },
            (error) => {
              console.log(error);
              hideLoader;
            }
          );
      }
    },
    onSelectRow(params) {
      if (params.selectedRows.length > 0) {
        this.selectItems = params.selectedRows;
      }
      return;
    },
    getCitiesByZone(zone_id) {
    if (zone_id) {
      showLoader();
      this.$http
        .get(`${this.$urlApi}cities/${zone_id}?token=${this.token}`)
        .then(
          (response) => {
            this.lstCiudad = response.data.data;
            this.getCustomers();
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    }
  },
  },
  
};
</script>
